export function omitFilter(val,defaultLength=15){
    if(val.length > (defaultLength-1)){
        let title =val.slice(0,defaultLength)+"..."
        return title
    }else{
        return val
    }
}


// WEBPACK FOOTER //
// ./src/filters/index.js